/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachRibCommand
 */
export interface AttachRibCommand {
    /**
     * ID of the uploaded RIB file (StoredFile)
     * @type {string}
     * @memberof AttachRibCommand
     */
    storedFileId: string;
    /**
     * Corrected IBAN after OCR validation (optional)
     * @type {string}
     * @memberof AttachRibCommand
     */
    iban?: string;
    /**
     * Corrected BIC after OCR validation (optional)
     * @type {string}
     * @memberof AttachRibCommand
     */
    bic?: string;
}

/**
 * Check if a given object implements the AttachRibCommand interface.
 */
export function instanceOfAttachRibCommand(value: object): value is AttachRibCommand {
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    return true;
}

export function AttachRibCommandFromJSON(json: any): AttachRibCommand {
    return AttachRibCommandFromJSONTyped(json, false);
}

export function AttachRibCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachRibCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
    };
}

export function AttachRibCommandToJSON(json: any): AttachRibCommand {
    return AttachRibCommandToJSONTyped(json, false);
}

export function AttachRibCommandToJSONTyped(value?: AttachRibCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
        'iban': value['iban'],
        'bic': value['bic'],
    };
}

